<template>
  <div class="users_filter">
    <div class="flex flex-between">
      <h5 class="users_filter--label">{{ label }}</h5>

      <div class="users_filter--select_all">
        <button-link
          @click="selectAll"
          class="users_filter--select_all--button"
        >select all
        </button-link>
        <button-link
          @click="deselectAll"
          class="users_filter--select_all--button"
        >deselect all
        </button-link>
      </div>
    </div>

    <div class="users_filter--list">
      <b-checkbox
        v-for="option in options"
        :key="option.id"
        v-model="filterValue"
        :native-value="option.id"
        @input="handleInput"
        size="is-small"
      >
        {{ option.full_name }}
      </b-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterUsers",
  props: {
    label: {
      type: String,
      default: "Users"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    initialUser: Number,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].users;
      },
      set(value) {
        this.commitUsers(value);
      }
    },
    options() {
      return [
        {id: 0, full_name: "No Users"},
        ...this.$store.getters.activeUsers,
      ];
    },
    text() {
      if (!this.filterValue.length) {
        return null;
      }

      let usersNameArray = [];

      this.filterValue.forEach(userId => {
        if (userId === 0) {
          usersNameArray.push("No Users");
        } else {
          const user = this.$store.getters.userById(userId);

          if (user) {
            usersNameArray.push(user.full_name);
          }
        }
      });

      return usersNameArray.join(", ");
    },
  },
  created() {
    if(this.initialUser) {
      this.commitUsers([this.initialUser])
    }

    this.handleInput();
  },
  methods: {
    selectAll() {
      this.filterValue = this.options.map(user => {
        return user.id;
      });
      this.handleInput();
    },
    deselectAll() {
      this.filterValue = [];
      this.handleInput();
    },
    commitUsers(ids) {
      this.$store.commit(this.storeModule + "/setOneFilter", [
        this.filterName,
        "users",
        ids
      ]);
    },
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.users_filter {

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }

  &--list {
    padding: 8px 4px 0;
  }
}

::v-deep .b-checkbox.checkbox {
  display: flex !important;
  margin-bottom: 4px;
}
</style>
